import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext/AuthContext';
import LogoutSVG from '../assets/Logout'; 
import { useMediaQuery } from 'react-responsive';

function LogoutButton({ className = '' }) {
    const navigate = useNavigate();
    const { logout } = useAuth(); // This logout should update isAuthenticated state
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const handleLogout = async () => {
        try {

            localStorage.removeItem('token'); // Remove the token from local storage
            logout(); // Update isAuthenticated state
            console.log('Logged out successfully');
            navigate('/login'); // Redirect to the login page after logout
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <button 
            onClick={handleLogout}
            className={`w-full text-left px-4 py-2 rounded-lg text-sm font-medium text-shi-green ${className}`}
        >
            Logout
        </button>
    );
}

export default LogoutButton;
